// @react/hooks/useWorkflow.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { workflowStore } from '@core/stores';

/**
 * React hook for NodeType operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useWorkflow } from '@react/hooks';
 *
 * const NodeTypeList = observer(() => {
 *   const store = useWorkflow();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useWorkflow() {
  return workflowStore;
}
